<template>
    <v-alert

            type="success"
            class="elevation-8"
            prominent
            v-t="'auth.recoverySuccess'"
    >
    </v-alert>
</template>

<script>
    export default {
        name: "RecoveryPasswordFormSuccess"
    }
</script>

<style scoped>

</style>